import { render, staticRenderFns } from "./PatentClaims.vue?vue&type=template&id=32dafdb6&scoped=true"
import script from "./PatentClaims.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatentClaims.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PatentClaims.vue?vue&type=style&index=0&id=32dafdb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dafdb6",
  null
  
)

export default component.exports